import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';

type TagStatus = 'completed' | 'in-progress' | 'todo' | 'error' | 'to-correct' | 'transition' | 'pending';

@Component({
  selector: 'dbw-consultant-relation-tag',
  imports: [OuiTagModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <oui-tag type="status" size="big" [status]="tagStatus()">
      {{ label() }}
    </oui-tag>
  `
})
export class ConsultantRelationTagComponent {
  readonly relationTypeCode = input<string | null | undefined>(undefined);

  protected readonly label = computed(() => {
    const value = this.relationTypeCode()?.trim();
    return value ? value : '-';
  });

  protected readonly tagStatus = computed<TagStatus>(() => {
    const normalized = normalizeValue(this.relationTypeCode());

    switch (normalized) {
      case 'PRIMAIRE':
        return 'completed';
      case 'SECONDAIRE':
        return 'in-progress';
      default:
        return 'pending';
    }
  });
}

function normalizeValue(value: string | null | undefined): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toUpperCase();
}
